import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Modal } from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";
import './AddPurchase.css';
import axios from "axios";

const EditLeavePermissionForm = () => {
  const { leave_id } = useParams();
  const navigate = useNavigate();
  const [customerList, setCustomers] = useState([]);
  // const [employeeList, setEmployee] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const userId = (localStorage.getItem("user_id") || "").replace(/"/g, "");
  const leaveStatus = (localStorage.getItem("leave_status") || "")
  const cleanLeaveStatus = leaveStatus.replace(/"/g, "");
  

  console.log("leaveStatus ", leaveStatus);
  console.log("leaveStatus raw:", leaveStatus);
  console.log("typeof leaveStatus:", typeof leaveStatus);
  console.log("trimmed:", leaveStatus.trim());
  console.log("equal to '1' ?", leaveStatus === "1");
  console.log("equal to number 1 ?", leaveStatus == 1);
  console.log("char codes:", leaveStatus.split("").map(c => c.charCodeAt(0)));

  const desigName = (localStorage.getItem("desig_name") || "")
    .replace(/"/g, "");   // remove extra quotes
  const [selectedUser, setSelectedUser] = useState(null);

  // console.log("%%%%%%%%%%%%%%%%%%%%%%%%", leaveStatus);
  // Example data — replace with API later

  const [formData, setFormData] = useState({
    user_id: "",
    // mobile: "",
    // address: "",
    type: "",
    session:"",
    aided_leave_type: "",
    date: "",
    duration: "",
    reason: "",
    work_adjustment_id: "",
    file: null,
    file_name: null,
    status: "Submitted",
    action_by: userId,
    // cancel: false,
  });

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [actionByDesig, setActionByDesig] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");



  const [attachmentPreview, setAttachmentPreview] = useState(null);
  // const [searchTerm, setSearchTerm] = useState("");
  const [conflictModal, setConflictModal] = useState({ show: false, message: "" });

  useEffect(() => {

    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });


    axios.post(`${API_BASE_URL}leave_permission_detail.php`, { leave_id: leave_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          const apiData = response.data.body;
          setActionByDesig(response.data.body.action_by_desig);
          setDepartment(response.data.body.depart_name);
          setDesignation(response.data.body.desig_name);

          // convert DD-MM-YYYY → YYYY-MM-DD
          const convertToInputDate = (dateStr) => {
            if (!dateStr) return "";
            const [dd, mm, yyyy] = dateStr.split("-");
            return `${yyyy}-${mm}-${dd}`;
          };

          const updatedData = {
            ...apiData,
            leave_date: convertToInputDate(apiData.leave_date),
            // action_by: userId,
          };
          // console.log("sdgefgsdgdasfsdgdsgsgd",apiData.user_id);
          setFormData(updatedData);
          setSelectedUser(apiData || null);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setFormData([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setFormData([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  // const filteredCustomers = customerList.filter((c) =>
  //   c.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // Filter out the current user from work adjustment options
  const workAdjustmentOptions = customerList.filter(
    (c) => c.work_adjustment_id !== formData.work_adjustment_id
  );

  const statusOptions = [
    { value: "Submitted", label: "Submitted" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      const file = files[0] || null;
      setFormData((prev) => ({ ...prev, [name]: file }));
      setAttachmentPreview(file ? URL.createObjectURL(file) : null);
    } else if (type === "checkbox") {
    } else if (name === "work_adjustment_id") {
      // setSearchTerm(value);
      const matched = customerList.find(
        (c) => c.user_id.toLowerCase() === value.toLowerCase()
      );
      if (matched) {
        setFormData((prev) => ({
          ...prev,
          work_adjustment_id: matched.user_id,
        }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectCustomer = (user_id) => {
    const selected = customerList.find((c) => c.user_id === user_id);
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        user_id: selected.user_id
      }));
      // setSearchTerm(selected.user_id);

      // Save selected user details in state
      setSelectedUser(selected || null);
    }
    // console.log("dggsgsdsgs",selected);
  };

  const validate = () => {
    const e = {};
    if (!formData.user_id.trim()) e.user_id = "Name is required";
    // if (!formData.mobile || !/^\d{10}$/.test(formData.mobile))
    //   e.mobile = "Enter valid 10-digit mobile";
    if (!formData.type) e.type = "Select type";
    if (!formData.leave_date) e.leave_date = "Select date";
    // Add validation for duration when type is permission
    if (formData.type === "permission" && !formData.duration) {
      e.duration = "Select duration for permission";
    }
    if (!formData.reason.trim()) e.reason = "Reason is required";
    // if (!formData.action_by.trim())
    //   e.action_by = "Action by (approver) is required";
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      setSuccessMsg("");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    setErrors({});
    console.log("check user id", userId);
    // Convert duration to number before submitting
    const payload = {
      ...formData,
      duration: formData.duration ? Number(formData.duration) : null,
      action_by: userId,
      // date: formData.date
      //   ? new Date(formData.date).toISOString().split("T")[0]
      //   : "",
      // attachmentName: formData.attachment ? formData.attachment.name : null,
    };

    console.log("Updated Leave/Permission Request:", payload);
    console.log("Duration type:", typeof payload.duration, "Value:", payload.duration);

    // TODO: Submit updated data to backend API
    console.log("==============", payload);
    /*  */
    axios.post(`${API_BASE_URL}leave_permission_detail_edit.php`, payload)
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          setSuccessMsg("Request updated successfully");
          navigate("/permissionleavelist")
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          if (response.data.head.msg.includes("Already Another Person Apply Leave for Same Date in Your Department")) {
            showConflictModal(
              `Another person from your department has already requested leave on same date. ` +
              `Only one staff member per department can take leave on the same date. ` +
              `Please choose a different date or coordinate with your team.`
            );
          }
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

  };

  const renderError = (field) =>
    errors[field] && (
      <div className="text-danger small mt-1">{errors[field]}</div>
    );

  const showConflictModal = (message) => {
    setConflictModal({ show: true, message });
  };

  const uploadFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64File = reader.result.split(",")[1]; // remove "data:.."
      setFormData({
        ...formData,
        file: base64File,
        file_name: file.name,
      });
    };

    reader.readAsDataURL(file);
  };



  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Edit Leave | Permission</h4>
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      {successMsg && <Alert variant="success">{successMsg}</Alert>}

      {/* Department Conflict Modal */}
      <Modal show={conflictModal.show} onHide={() => setConflictModal({ show: false, message: "" })}>
        <Modal.Header closeButton>
          <Modal.Title>Department Leave Conflict</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            {conflictModal.message}
          </Alert>
          <p className="mb-0">
            <strong>Note:</strong> Permission requests are not affected by this rule.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setConflictModal({ show: false, message: "" })}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* 🔽 Customer Name Dropdown + Search */}
          <Col lg={4} md={4}>
            <Form.Group>
              <Form.Label>User</Form.Label>
              <Form.Select
                name="user_id"
                value={formData.user_id}
                onChange={(e) => handleSelectCustomer(e.target.value)}
                className="custom-select-arrow"
              >
                <option value="">Select User</option>
                {customerList.map((c, idx) => (
                  <option key={idx} value={c.user_id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("user_id")}
            </Form.Group>
          </Col>

          {/* 🔒 Read-only Mobile */}
          {/* <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                value={formData.mobile}
                readOnly
                placeholder="Auto-filled"
              />
              {renderError("mobile")}
            </Form.Group>
          </Col> */}

          <Col lg={4} md={4}>
            <Form.Group>
              <Form.Label>Type</Form.Label>
              <Form.Select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Type</option>
                <option value="Leave">Leave</option>
                <option value="Half Day Leave">Half Day Leave</option>
                <option value="Permission">Permission</option>
              </Form.Select>
              {renderError("type")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4}>
  {formData.type === "Half Day Leave" && (
    <Form.Group className="mt-3">
      <Form.Label>Session</Form.Label>
      <div className="d-flex gap-4">
        <Form.Check
          type="radio"
          label="Forenoon"
          name="session"
          value="FN"                              // ✅ fixed value
          checked={formData.session === "FN"}     // ✅ bound to formData
          onChange={handleChange}                 // ✅ updates formData
          className="dark-radio"
        />

        <Form.Check
          type="radio"
          label="Afternoon"
          name="session"
          value="AN"                              // ✅ fixed value
          checked={formData.session === "AN"}
          onChange={handleChange}
          className="dark-radio"
        />
      </div>
      {renderError("session")}
    </Form.Group>
  )}
</Col>


          {/* Date and Duration in the same row */}
          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="leave_date"
                value={formData.leave_date}
                onChange={handleChange}
              />
              {renderError("leave_date")}
            </Form.Group>
          </Col>

          {selectedUser?.staff_type != "Aided" && formData.type != "Permission" && (
            <Col lg={6} md={12}>
              <Form.Group>
                <Form.Label>Leave Type</Form.Label>
                <Form.Control
                  type="text"
                  // name="reason"
                  value="CL"
                  // onChange={handleChange}
                  readOnly
                  placeholder="Brief reason for leave/permission"
                />
                {renderError("reason")}
              </Form.Group>
            </Col>
          )}

          {(selectedUser?.staff_type === "Aided") && (
            <Col lg={6} md={12}>
              <Form.Group>
                <Form.Label>Leave Type</Form.Label>
                <Form.Select
                  name="aided_leave_type"
                  value={formData.aided_leave_type}
                  onChange={handleChange}
                  className="custom-select-arrow"
                >
                  <option value="">Select</option>
                  <option value="CL">CL</option>
                  {selectedUser.remaining_leave_ml > 0 && (<option value="ML">ML</option>)}
                  {selectedUser.remaining_leave_rl > 0 && (<option value="RL">RL</option>)}
                  {selectedUser.remaining_leave_el > 0 && (<option value="EL">EL</option>)}
                  {selectedUser.remaining_leave_uel > 0 && (<option value="UEL">UEL</option>)}
                  {selectedUser.maternity_leave > 0 && selectedUser.gender == "Female" && (<option value="Maternity Leave">Maternity Leave</option>)}

                </Form.Select>
                {renderError("aided_leave_type")}
              </Form.Group>
            </Col>
          )}

          {/* New Duration Field - Show for both types but only required for permission */}
          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Duration (Hours)</Form.Label>
              <Form.Select
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                className="custom-select-arrow"
                required={formData.type === "permission"}
              >
                <option value="">Select Hours</option>
                {[1, 2, 3, 4, 5, 6, 7].map((hour) => (
                  <option key={hour} value={hour}>
                    {hour} {hour === 1 ? "hour" : "hours"}
                  </option>
                ))}
              </Form.Select>
              {renderError("duration")}
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Brief reason for leave/permission"
              />
              {renderError("reason")}
            </Form.Group>
          </Col>

          {/* Updated Work Adjustment - Now a dropdown */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Work Adjustment</Form.Label>
              <Form.Select
                name="work_adjustment_id"
                value={formData.work_adjustment_id}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select who will handle your work</option>
                {customerList.map((c, idx) => (
                  <option key={idx} value={c.user_id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
              <Form.Text className="text-muted">
                Select the colleague who will handle your work during your absence
              </Form.Text>
            </Form.Group>
          </Col>

          {/* Updated Action By - Now a dropdown */}
          {/* <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Action By (Approver)</Form.Label>
              <Form.Select
                name="action_by"
                value={formData.action_by}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Approver</option>
                {employeeList.map((employee, idx) => (
                  <option key={idx} value={employee.user_id}>
                    {employee.user_name}
                  </option>
                ))}
              </Form.Select>
              {renderError("action_by")}
            </Form.Group>
          </Col> */}

          {cleanLeaveStatus === "1" ? (

            (((desigName === "AO" || desigName === "Principal") && actionByDesig === "HOD") ||
              ((desigName === "AO" || desigName === "Principal") && (department == "Non Teaching Staff" || designation == "HOD")))
              ? (
                <Col lg={6} md={12}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      {statusOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>) : (
                ((actionByDesig === "AO" || actionByDesig === "Principal") && desigName === "Correspondent") ? (
                  // CASE 2
                  <Col lg={6} md={12}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select name="status" value={formData.status} onChange={handleChange}>
                        {statusOptions.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                ) : null
              )
          ) : null}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>
                Attachment <span className="text-muted small">(MC)</span>
              </Form.Label>

              {/* Upload New File */}
              <Form.Control
                type="file"
                name="file"
                // accept="image/*,application/pdf"
                accept="application/pdf"
                onChange={uploadFile}
              // onChange={async (e) => {
              //   const file = e.target.files[0];
              //   if (file) {
              //     const reader = new FileReader();
              //     reader.onloadend = () => {
              //       setFormData((prev) => ({
              //         ...prev,
              //         file: {
              //           name: file.name,
              //           type: file.type,
              //           base64: reader.result, // full Base64 string
              //         },
              //       }));
              //     };
              //     reader.readAsDataURL(file);
              //   } else {
              //     setFormData((prev) => ({ ...prev, file: null }));
              //   }
              // }}
              />

              {/* Show selected new file */}
              {formData.file && (
                <div className="mt-2 small text-muted">
                  Selected: {formData.file.name}
                </div>
              )}

              {/* Show existing file from API (if user did NOT upload a new file) */}
              {formData.file && (
                <div className="mt-2">
                  <a
                    href={formData.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    // style={{ fontSize: "14px" }}
                    style={{ fontSize: "14px", textDecoration: 'underline', color: '#0d6efd' }}
                  >
                    {formData.file_name}
                  </a>
                </div>
              )}
            </Form.Group>
          </Col>



          {/* 🔒 Read-only Address */}
          {/* <Col lg={6}>
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="address"
                value={formData.address}
                readOnly
                placeholder="Auto-filled address"
              />
            </Form.Group>
          </Col> */}
        </Row>

        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">
            Update
          </Button>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditLeavePermissionForm;